export default function Turbon() {
  return (
    <iframe
      className="h-full w-full bg-vscode"
      src="http://tiny.rocke.top"
      frameBorder="0"
      title="Turbon Manager"
    />
  );
}
